module.exports = __webpack_public_path__ + "img/13_Gussformer_Foto.03520819.jpg";